import { injectGlobal } from 'styled-components';

injectGlobal`
  body {
    margin: 0;
    padding: 0;
    font-family: sans-serif;
  }

  a {
    color: #000;
    text-decoration: none;
  }
`;



// WEBPACK FOOTER //
// ./src/indexCSS.js